import { styled } from '@mui/material';

export const Container = styled('span', { shouldForwardProp: prop => prop !== 'reviews' && prop !== 'sx' })<{
  reviews: number;
}>(({ reviews }) => ({
  alignItems: 'center',
  cursor: reviews > 0 ? 'pointer' : 'initial',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

export const InnerContainer = styled('span')({
  alignItems: 'center',
  display: 'flex',
});
